import { forwardRef, type Ref, type SVGProps } from "react";
const IconDiningRoomFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15.115 4.99v3.574c-1.196.201-2.062.781-2.648 1.522-.698.88-.94 1.906-1.006 2.576-.083.827.595 1.416 1.296 1.416h6.695c.7 0 1.384-.59 1.294-1.424-.073-.684-.337-1.708-1.05-2.582-.587-.72-1.439-1.287-2.602-1.497V4.99a.99.99 0 0 0-1.979 0" />
    <path d="M7.199 18.177a.99.99 0 1 0 0 1.98h.838l-2 6.63a.924.924 0 0 0 .663 1.185c.526.127 1.082-.199 1.241-.727l2.139-7.089h1.402l-.591 4.87a.92.92 0 0 0 .868 1.043 1.063 1.063 0 0 0 1.107-.922l.606-4.99h5.056l.606 4.99c.066.543.561.955 1.107.922a.92.92 0 0 0 .868-1.043l-.591-4.87h1.402l2.139 7.089c.16.528.715.854 1.24.727a.924.924 0 0 0 .664-1.186l-2-6.63h1.048a.99.99 0 1 0 0-1.979z" />
  </svg>
);
const ForwardRef = forwardRef(IconDiningRoomFilledSVG);
ForwardRef.displayName = "IconDiningRoomFilled";
export { ForwardRef as IconDiningRoomFilled };
